import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  DashboardFiltros,
  DashboardGraficosResult,
  PipelineProjetosResult,
  ReceitaTemporalResult,
  MovimentacaoEstoqueResult,
  StatusOrdensCompraResult,
  ProjetosPorStatusResult,
  ProjetosPorFeiraResult,
  ProjetosTemporalResult,
  OrcamentosGraficosResult,
  ListaDeContatosGeradosResponse,
  ProjetosPorStatusResponse
} from '../models/dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private apiUrl = environment.apiUrl + '/v1/Dashboard';

  constructor(private http: HttpClient) {}

  consultarTodosGraficos(filtros: DashboardFiltros): Observable<DashboardGraficosResult> {
    let params = this.buildParams(filtros);
    return this.http.get<DashboardGraficosResult>(`${this.apiUrl}/graficos`, { params });
  }

  consultarPipelineProjetos(filtros: DashboardFiltros): Observable<PipelineProjetosResult> {
    let params = this.buildParams(filtros);
    return this.http.get<PipelineProjetosResult>(`${this.apiUrl}/graficos/pipeline-projetos`, { params });
  }

  consultarReceitaTemporal(filtros: DashboardFiltros): Observable<ReceitaTemporalResult> {
    let params = this.buildParams(filtros);
    return this.http.get<ReceitaTemporalResult>(`${this.apiUrl}/graficos/receita-temporal`, { params });
  }

  consultarMovimentacaoEstoque(filtros: DashboardFiltros): Observable<MovimentacaoEstoqueResult> {
    let params = this.buildParams(filtros);
    return this.http.get<MovimentacaoEstoqueResult>(`${this.apiUrl}/graficos/movimentacao-estoque`, { params });
  }

  consultarStatusOrdensCompra(filtros: DashboardFiltros): Observable<StatusOrdensCompraResult> {
    let params = this.buildParams(filtros);
    return this.http.get<StatusOrdensCompraResult>(`${this.apiUrl}/graficos/status-ordens-compra`, { params });
  }

  consultarProjetosPorStatus(filtros: DashboardFiltros): Observable<ProjetosPorStatusResult> {
    let params = this.buildParams(filtros);
    return this.http.get<ProjetosPorStatusResult>(`${this.apiUrl}/graficos/projetos-por-status`, { params });
  }

  consultarProjetosPorFeira(filtros: DashboardFiltros): Observable<ProjetosPorFeiraResult> {
    let params = this.buildParams(filtros);
    return this.http.get<ProjetosPorFeiraResult>(`${this.apiUrl}/graficos/projetos-por-feira`, { params });
  }

  consultarProjetosTemporal(filtros: DashboardFiltros): Observable<ProjetosTemporalResult> {
    let params = this.buildParams(filtros);
    return this.http.get<ProjetosTemporalResult>(`${this.apiUrl}/graficos/projetos-temporal`, { params });
  }

  consultarTodosOrcamentosGraficos(filtros: DashboardFiltros): Observable<OrcamentosGraficosResult> {
    let params = this.buildParams(filtros);
    return this.http.get<OrcamentosGraficosResult>(`${this.apiUrl}/graficos/orcamentos`, { params });
  }

  // Métodos para gráficos financeiros individuais (caso o endpoint principal não os retorne)
  consultarMargemLucroDistribuicao(filtros: DashboardFiltros): Observable<any> {
    let params = this.buildParams(filtros);
    return this.http.get<any>(`${this.apiUrl}/financeiro/orcamentos/margem-lucro-distribuicao`, { params });
  }

  consultarCustoVsReceita(filtros: DashboardFiltros): Observable<any> {
    let params = this.buildParams(filtros);
    return this.http.get<any>(`${this.apiUrl}/financeiro/orcamentos/custo-vs-receita`, { params });
  }

  consultarComposicaoCustos(filtros: DashboardFiltros): Observable<any> {
    let params = this.buildParams(filtros);
    return this.http.get<any>(`${this.apiUrl}/financeiro/orcamentos/composicao-custos`, { params });
  }

  consultarPercentuais(filtros: DashboardFiltros): Observable<any> {
    let params = this.buildParams(filtros);
    return this.http.get<any>(`${this.apiUrl}/financeiro/orcamentos/percentuais`, { params });
  }

  consultarVariacao(filtros: DashboardFiltros): Observable<any> {
    let params = this.buildParams(filtros);
    return this.http.get<any>(`${this.apiUrl}/financeiro/orcamentos/variacao`, { params });
  }

  consultarReceitaMetroQuadrado(filtros: DashboardFiltros): Observable<any> {
    let params = this.buildParams(filtros);
    return this.http.get<any>(`${this.apiUrl}/financeiro/orcamentos/receita-metro-quadrado`, { params });
  }

  private buildParams(filtros: DashboardFiltros): HttpParams {
    let params = new HttpParams()
      .set('tipoPeriodo', filtros.tipoPeriodo.toString())
      .set('ano', filtros.ano.toString());

    if (filtros.mes) {
      params = params.set('mes', filtros.mes.toString());
    }
    if (filtros.dataInicio) {
      params = params.set('dataInicio', filtros.dataInicio);
    }
    if (filtros.dataFim) {
      params = params.set('dataFim', filtros.dataFim);
    }
    if (filtros.feiraId) {
      params = params.set('feiraId', filtros.feiraId);
    }
    if (filtros.clienteId) {
      params = params.set('clienteId', filtros.clienteId);
    }
    if (filtros.listaId) {
      params = params.set('listaId', filtros.listaId);
    }

    return params;
  }

  consultarListasDeContatosGerados(): Observable<ListaDeContatosGeradosResponse> {
    return this.http.get<ListaDeContatosGeradosResponse>(`${environment.apiUrl}/v1/ListaDeContatosGerados`);
  }

  consultarProjetosPorListaStatus(status: number[]): Observable<ProjetosPorStatusResponse> {
    let params = new HttpParams();
    status.forEach(s => {
      params = params.append('Status', s.toString());
    });
    return this.http.get<ProjetosPorStatusResponse>(`${environment.apiUrl}/v1/Projetos/por-status`, { params });
  }
}

